import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import backgroundImage from '../assets/images/select/bg.png'
import yellowBtn from '../assets/images/select/yellow-btn.png'
import redBtn from '../assets/images/select/red-btn.png'
import blueBtn from '../assets/images/select/blue-btn.png'
import yellowSelectBtn from '../assets/images/select/yellow-select.png'
import redSelectBtn from '../assets/images/select/red-select.png'
import blueSelectBtn from '../assets/images/select/blue-select.png'
import confirm from '../assets/images/select/confirm.png';

class Select extends Component {

    btnSound = './sounds/button_sound.mp3';

    constructor(props) {
        super(props);
        this.state = {
            yellowImage: yellowSelectBtn,
            redImage: redBtn,
            blueImage: blueBtn,
            selectedIndex: 0
        };
    }
    
    goToStageSelectPage() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './stage-select',
            state: {
                selectedIndex: this.state.selectedIndex
            }
        });
    };

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    onImageClicked(index) {
        this.playBtnSound()
        this.setState({
            yellowImage: index === 0 ? yellowSelectBtn : yellowBtn,
            redImage: index === 1 ? redSelectBtn : redBtn,
            blueImage: index === 2 ? blueSelectBtn : blueBtn,
            selectedIndex: index
        });
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <img className='press-btn' alt='' src={this.state.yellowImage} style={{ height: '40%', bottom: '27%', left: '14.5%', position: 'absolute', background: 'transparent' }} onClick={() => this.onImageClicked(0)}/>
                <img className='press-btn' alt='' src={this.state.redImage} style={{ height: '40%', bottom: '27%', left: '39.5%', position: 'absolute', background: 'transparent' }} onClick={() => this.onImageClicked(1)}/>
                <img className='press-btn' alt='' src={this.state.blueImage} style={{ height: '40%', bottom: '27%', left: '64.5%', position: 'absolute', background: 'transparent' }} onClick={() => this.onImageClicked(2)}/>
                <img className='press-btn' alt='' src={confirm} style={{ width: '19%', position: 'absolute', left: '40%', bottom: '8%' }} onClick={this.goToStageSelectPage.bind(this)}></img>
            </div>
        )
    }
}

export default withRouter(Select);
